import { Star } from 'lucide-react';

import { Text } from '@/components/text';

const OpenSavedItemsEmpty = () => {
  return (
    <div className="mt-1 rounded-md border border-blue-500 p-2.5 pt-2">
      <Text variant="sm" className="mb-0 leading-snug text-white/70">
        Any items you <Star className="relative top-[2px] size-3 text-yellowMid" /> star will appear here and on your
        Dashboard for quick access.
      </Text>
    </div>
  );
};

export { OpenSavedItemsEmpty };
